export class PosDeviceBriefDto {
  id: number;
  name: string;
  enabled: boolean;
}
